import {gql} from "@apollo/client";

export const DUAL_PROVIDER_AVAILABLE_REPORTS_QUERY = gql`
    query dualProviderAvailableReports($clientGuid: String!) {
        dualProviderAvailableReports(clientGuid: $clientGuid) {
            guid
            reportType
            submittedAt
            reportStatus
            fileName
            bhpnAuthorizationNumber
        }
    }
`;

export const LATEST_CARE_COORDINATION_REQUEST_QUERY = gql`
    query clientProfileQuery($clientProfileGuid: ID!) {
        clientProfileQuery(id: $clientProfileGuid) {
            latestCareCoordinationRequest {
                guid
                status
            }
        }
    }
`;

export const SUBMIT_CARE_COORDINATION_REQUEST_MUTATION = gql`
    mutation submitCareCoordinationRequest(
        $clientGuid: String!,
        $additionalNotes: String,
        $reportGuids: [String!]!
    ) {
        submitCareCoordinationRequest(
            clientGuid: $clientGuid,
            additionalNotes: $additionalNotes,
            reportGuids: $reportGuids
        )
    }
`;

export type AvailableReport = {
    guid: string;
    reportType: string;
    submittedAt: string;
    reportStatus: string;
    fileName: string | null;
    bhpnAuthorizationNumber: string | null;
};

export type DualProviderAvailableReportsResult = {
    dualProviderAvailableReports: AvailableReport[];
};

export type LatestCareCoordinationRequestResult = {
    clientProfileQuery: {
        latestCareCoordinationRequest: {
            guid: string;
            status: string;
        } | null;
    };
};
